/// <amd-module name="Environments/Landing/Common/Constants" />
export const EnvironmentsNameFilterKey: string = "EnvironmentsNameFilter";
export const DeploymentStatusFilterKey: string = "DeploymentStatusFilter";
export const EnvironmentsDefaultTabKey: string = "available";
export const EnvironmentsView: string = "environments";
export const EnvironmentsDataProviderContribution: string = "ms.vss-environments-web.environments-landing-data-provider";
export const CheckIssuesDataProviderContribution: string = "ms.vss-pipelinechecks.checks-issues-provider";

export namespace PerformanceScenarios {
    export const EnvironmentsZeroDataPageLoad = "Pipelines.Environments.ZeroData";
    export const EnvironmentsListPageLoad = "Pipelines.Environments.List";
}

